<template>
  <path
    d="M17 1.00024H7C5.9 1.00024 5 1.90024 5 3.00024V21.0002C5 22.1002 5.9 23.0002 7 23.0002H17C18.1 23.0002 19 22.1002 19 21.0002V3.00024C19 1.90024 18.1 1.00024 17 1.00024ZM17 18.0002H7V6.00024H17V18.0002ZM12.5 11.0002V9.12024C12.5 8.59024 11.79 8.42024 11.55 8.90024L9.86 12.2802C9.7 12.6102 9.94 13.0002 10.31 13.0002H11.5V14.8802C11.5 15.4102 12.21 15.5802 12.45 15.1002L14.14 11.7202C14.3 11.3902 14.06 11.0002 13.69 11.0002H12.5Z"
  />
</template>
